<template>
    <div class="page_container">
        <div class="page_header">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>公司管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <el-card class="page_card">
<!--          <el-form size="small" @submit.native.prevent :inline="true">-->
<!--            <div class="">-->
<!--              <div>-->
<!--                <el-form-item label="">-->
<!--                  <el-input v-model="searchForm.keyWords" placeholder="请输入需要查询的内容" @clear="handleClickSearch()" @keyup.enter.native="handleClickSearch"  clearable  suffix-icon="el-icon-search"></el-input>-->
<!--                </el-form-item>-->
<!--                <el-button size="small"  @click="handleClickReset">重置</el-button>-->
<!--              </div>-->
<!--            </div>-->
<!--          </el-form>-->

          <template>
            <el-table ref="table1" :data="tableData" style="width: 100%" :height="tableHeight">
              <el-table-column prop="uid" align="center" label="序号" width="80"></el-table-column>
              <el-table-column prop="company_name" align="center" label="企业名称" min-width="120">
                <template slot-scope="{row}">
                   <span  @click="handleClickUserDetail(row)">{{row.company_name}}</span>
                </template>
              </el-table-column>


              <el-table-column prop="industry" align="center" label="所属行业" min-width="160"></el-table-column>
              <el-table-column prop="legal_name" align="center" label="法人姓名" min-width="160"></el-table-column>
<!--              <el-table-column prop="email" align="center" label="创建人账号" min-width="120"></el-table-column>-->
              <el-table-column prop="create_date" align="center" label="创建时间" min-width="140">
                <template slot-scope="{row}">
                    <span v-if="row.create_date" v-text="convertToCurrentTimezone(row.create_date,'/','datetime')"></span>
                </template>
              </el-table-column>
              <el-table-column prop="status" align="center" label="企业状态" min-width="120">
                <template slot-scope="{row}">
                  <span v-text="row.status == 0 ?'审核中':row.status == 1 ? '通过' : row.status == 2 ? '驳回' : ''"></span>
                </template>
              </el-table-column>
              <el-table-column prop="date" align="center" label="操作" min-width="120">

              </el-table-column>
            </el-table>
          </template>


          <el-pagination background
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page="pagination.pageNum"
                         :page-sizes="pagination.pageSizes"
                         :page-size="pagination.pageSize"
                         :layout="pagination.layout"
                         :total="pagination.total">
          </el-pagination>


        </el-card>
    </div>
</template>

<script>
import {adminCompanyList } from '@/api/api'
import {getTableHeight,convertToCurrentTimezone} from '@/utils'
import {pagination} from '@/mixins'
import {mapState} from "vuex";

export default {
    name: 'individual_users',

    data() {
        return {
          loading:false,
          tableData:[ ],
          tableHeight:'',
          searchForm:{
            keyWords:''
          }
        }
    },

    mixins: [pagination],
    created() {
      //将计算的table高度赋值给table
      this.tableHeight = getTableHeight(210)
    },
    mounted() {
      this.getTableData()
      //窗口缩放时动态修改table的高度
      window.onresize = () => {
        if (this.resizeTimer) {
          clearTimeout(this.resizeTimer)
        }
        //开启定时器，节流函数
        this.resizeTimer = setTimeout(() => {
          //将计算的table高度赋值给table
          this.tableHeight = getTableHeight(210)
          //清除定时器
          this.resizeTimer = null
        }, 100)
      }
    },
    computed: {
      ...mapState(['adminUserInfo']),
    },
    methods: {
      convertToCurrentTimezone(utcTime,separator,type) {
        return convertToCurrentTimezone(utcTime,separator,type);
      },
      handleClickUserDetail(row){
        // this.$router.push({name:'enterprise_detail',query:{id:row.id}});
      },

      getTableData() {
        this.loading = true
        let postData = {
          page: this.pagination.pageNum,
          pageSize: this.pagination.pageSize,
          name:this.searchForm.keyWords
        }
        adminCompanyList(postData).then(res => {
          if (res.code === 200) {
            let {total, data} = res.data
            this.tableData = data
            this.pagination.total = total
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      handleSizeChange(val) {
        this.pagination.pageNum = 1
        this.pagination.pageSize = val
        this.getTableData()
      },
      handleCurrentChange(val) {
        this.pagination.pageNum = val
        this.getTableData()
      },
      // 搜索
      handleClickSearch(){
        this.pagination.pageNum = 1
        this.getTableData()
      },
      // 重置
      handleClickReset(){
        this.searchForm.keyWords = ''
        this.pagination.pageNum = 1
        this.getTableData()
      },

    },
    watch: {

    },
}
</script>

<style scoped lang="scss">
.kx {
    width: 100%;
    height: 30px;
}
.chart{
    height:540px
}
.page_container .page_card {
    overflow-y: scroll;
    padding-bottom: 20px;
}

.filed_list{
  color: #000;
  line-height: 24px;
  font-size: 16px;
  margin-bottom: 12px;
}
</style>
